"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _api = require("@lce/api");

var _slice = require("@lce/slice");

var _cart = require("@lce/cart");

var _AccountMenu = _interopRequireDefault(require("../AccountMenu"));

var _AccountMenu_V = _interopRequireDefault(require("../AccountMenu_V2"));

var _Logo = _interopRequireDefault(require("../Logo"));

var Styled = _interopRequireWildcard(require("./Mobile.style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj["default"] = obj;
    return newObj;
  }
}

var Mobile = function Mobile(_a) {
  var hideAccount = _a.hideAccount,
      hideCart = _a.hideCart,
      isSticky = _a.isSticky;

  var _b;

  var settings = (0, _api.useSettings)().data;

  var _c = (0, _react.useState)(false),
      isOpen = _c[0],
      setIsOpen = _c[1];

  var isAccountMenuV2 = (_b = settings === null || settings === void 0 ? void 0 : settings.FEATURE) === null || _b === void 0 ? void 0 : _b.ACCOUNT_V2;
  var AccountModal = isAccountMenuV2 ? _AccountMenu_V["default"].Modal : _AccountMenu["default"].Modal;
  (0, _react.useEffect)(function () {
    var _a;

    !isOpen && ((_a = document.getElementById('header__hamburger-button')) === null || _a === void 0 ? void 0 : _a.focus());
  }, [isOpen]);
  return _react["default"].createElement(Styled.Mobile, {
    "data-testid": "header__mobile__wrapper",
    isSticky: isSticky
  }, _react["default"].createElement(_slice.Flex, {
    alignItems: "center",
    as: "nav",
    flexDirection: "row"
  }, !hideAccount ? _react["default"].createElement(Styled.HamburgerContainer, {
    isOpen: isOpen,
    isSticky: isSticky
  }, _react["default"].createElement(Styled.HamburgerIcon, {
    "data-testid": "header__mobile__account",
    isSticky: isSticky,
    mr: 2
  }, _react["default"].createElement(AccountModal, {
    isOpen: isOpen,
    setIsOpen: setIsOpen
  }))) : null, _react["default"].createElement(Styled.Logo, {
    flex: "1 1 auto"
  }, _react["default"].createElement(_Logo["default"], null)), !hideCart ? _react["default"].createElement(Styled.Icon, {
    "data-testid": "header__mobile__cart",
    ml: 2
  }, _react["default"].createElement(_cart.Cart.Modal, null)) : null));
};

var _default = Mobile;
exports["default"] = _default;